import { Object3D, Vector2Tuple } from 'three';

import { FurnitureShallowNode } from '@spazious/dollhouse-shallow-graph';

import { Collider } from '../core/index.js';
import { ColliderNode, FCompositionNode, FNodeTypesEnum, FurnitureNode } from '../types/index.js';

import { BaseNodeImpl } from './BaseNode.js';

export class FurnitureNodeImpl extends BaseNodeImpl implements FurnitureNode {
  type: FNodeTypesEnum.Furniture = FNodeTypesEnum.Furniture;
  shallow: FurnitureShallowNode | null = null;
  id: number = 0;
  name: string = '';
  position: Vector2Tuple = [0, 0];
  rotation: number = 0;
  url: string = '';
  furnitureType: string = '';
  visible: boolean = true;
  object: Object3D | null = null;
  collider: Collider | null = null;
  collisions: ColliderNode[] = [];
  originator: FCompositionNode | null = null;
  get outline2D() {
    return this.object?.outline2D ?? null;
  }
  computeOutline2D() {
    this.object?.computeOutline2D();
  }
  toJSON(recursive?: boolean) {
    return {
      ...super.toJSON(recursive),
      id: this.id,
      name: this.name,
      url: this.url,
      position: this.position,
      rotation: this.rotation,
      furnitureType: this.furnitureType,
      visible: this.visible,
      shallow: this.shallow,
      collisions: this.collisions.map((node) => node.selector),
      // Causes endless recursion in some JSON.stringify serializers
      // originator: this.originator,
    };
  }
}
